module.exports = __webpack_public_path__ + "img/iconyoutube.3e55227a.png";